import styles from './LocationPin.module.css';

/** Pin outline + centre cut-out, extracted from Figma ("Pins", 781:109700). */
export const PIN_PATH =
  'M26.23 0C40.72 0 52.46 11.74 52.46 26.23C52.46 32.43 50.3 38.13 46.7 42.62L46.71 42.62C46.7 42.62 46.65 42.69 46.54 42.82C46.51 42.86 46.48 42.9 46.44 42.94C45.59 43.99 42.76 47.4 39.34 50.82C35.25 54.92 26.26 64 26.26 64C26.23 63.97 17.21 54.91 13.11 50.82C9.7 47.4 6.87 43.99 6.02 42.94C5.98 42.9 5.95 42.86 5.91 42.82C5.81 42.69 5.75 42.62 5.75 42.62L5.75 42.62C2.15 38.13 0 32.43 0 26.23C0 11.74 11.74 0 26.23 0ZM26.23 16.41C20.8 16.41 16.4 20.82 16.4 26.26C16.4 31.69 20.8 36.1 26.23 36.1C31.66 36.1 36.07 31.69 36.07 26.26C36.07 20.82 31.66 16.41 26.23 16.41Z';

export const PIN_WIDTH = 53;
export const PIN_HEIGHT = 64;

type LocationPinMarkProps = {
  clipId: string;
  width: number;
  height: number;
};

/**
 * Two-tone pin drawn as vector paths + a rectangular clipPath (not an alpha
 * mask). SVG masks are often rasterized at 1× CSS px on mobile, which makes
 * the pin look soft/pixelated on retina screens.
 */
export function LocationPinMark({ clipId, width, height }: LocationPinMarkProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${PIN_WIDTH} ${PIN_HEIGHT}`}
      fill="none"
      className={styles.svg}
      shapeRendering="geometricPrecision"
    >
      <defs>
        <clipPath id={clipId} clipPathUnits="userSpaceOnUse">
          <rect
            x={PIN_WIDTH / 2}
            y="0"
            width={PIN_WIDTH / 2}
            height={PIN_HEIGHT}
          />
        </clipPath>
      </defs>
      <path d={PIN_PATH} fill="currentColor" />
      <path d={PIN_PATH} className={styles.tint} clipPath={`url(#${clipId})`} />
    </svg>
  );
}
